function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    let detailsElement;
    if (summaryElement.hasAttribute("menu-drawer-inner-close")) {
      detailsElement = summaryElement.closest("details");
    } else {
      detailsElement = summaryElement.parentNode;
    }
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    document.documentElement.style.setProperty("--announcement-height", `-${document.querySelector("#shopify-section-announcement-bar").clientHeight}px`);
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.renderProductInfo();
      this.updateVariantInput();
      this.updateURL();
      this.updateMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );

  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    console.log(this.currentVariant.featured_media.id);
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    var slideno = $(newMedia).data("slide");
    $(".product_slider").slick("slickGoTo", slideno - 1);

    if (!newMedia) return;
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (modalContent) {
      const newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
    }

    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;

    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader =
      this.stickyHeader || document.querySelector("sticky-header");
    this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    window.setTimeout(() => {
      parent
        .querySelector("li.product__media-item")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      if (this.currentVariant && input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }


  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions = this.updateOptions.bind(this);
    this.updateOptionAvailability = this.updateOptionAvailability.bind(this);
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    this.updateOptionAvailability();
  }

  updateOptionAvailability() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const variantData = this.getVariantData();

    fieldsets.forEach((fieldset, optionIndex) => {
      const inputs = Array.from(fieldset.querySelectorAll("input"));
      const availableOptions = new Set();

      variantData.forEach((variant) => {
        if (this.isVariantAvailable(variant, optionIndex)) {
          availableOptions.add(variant.options[optionIndex]);
        }
      });

      inputs.forEach((input) => {
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        if (availableOptions.has(input.value)) {
          label.classList.remove('sold_out');
        } else {
          label.classList.add('sold_out');
        }
      });
    });
  }

  isVariantAvailable(variant, currentOptionIndex) {
    for (let i = 0; i < currentOptionIndex; i++) {
      if (variant.options[i] !== this.options[i]) {
        return false;
      }
    }
    return variant.available;
  }

  onVariantChange() {
    super.onVariantChange();
    this.updateOptionAvailability();
  }
}

customElements.define("variant-radios", VariantRadios);

//PDP Swatches
class ProductMain extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      relatedColors: '[js-related-colors]'
    }

  }

  connectedCallback() {
    const productJSON = this.querySelector(this._selectors.productJSON);
    this.product = productJSON && JSON.parse(productJSON.innerHTML);
    this.addEventListener('variant:change', this._handleVariantChange);

    this._initRelatedColors();
  }


  async _initRelatedColors() {
    this.relatedColorsContainer = this.querySelectorAll(this._selectors.relatedColors);

    if (this.relatedColorsContainer.length < 1) {
      return;
    }

    const currentProductHandle = this.relatedColorsContainer[0].getAttribute('data-handle');
    const relatedColorsTag = this.relatedColorsContainer[0].getAttribute('data-tag');

    const targetURL = `/collections/shop-all/${relatedColorsTag}/?view=json`;
    const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);
    let relatedColorsMarkup = '';

    if (relatedColorsJSON.length <= 1) {
      return;
    }


    relatedColorsJSON.forEach((product) => {
      let productURL = product.url
      let language;
      const windowURL = window.location.href;
      let firstString = windowURL.split('/');
      if (firstString[3].includes('-')) {
        language = '/' + firstString[3]
        productURL = language + productURL
      }

      if (product.handle == currentProductHandle) {
        relatedColorsMarkup = `${relatedColorsMarkup}<div class="product-related-colors__current block" aria-current="true" aria-label="${product.color}"><img class="product-related-colors__image" src="${product.swatch}" alt="${product.color}"/></div>`
      } else {
        relatedColorsMarkup = `${relatedColorsMarkup}<a href="${productURL}" class="product-related-colors__related block" aria-label="${product.color}"><img class="product-related-colors__image" src="${product.swatch}" alt="${product.color}" js-color-swatch-link></a>`
      }
    })

    this.relatedColorsContainer.forEach(container => {
      container.innerHTML = relatedColorsMarkup;
      container.classList.remove('hidden');
    })

    this._handleColorHover()
    // this._saveSelectedSize();
  }

  _handleColorHover() {
    const currentColor = document.querySelector(".product-related-colors__current");
    const currentColorText = document.querySelector(".product__variant-color");

    this.relatedColorsContainer[0].addEventListener('mouseover', function (event) {
      const target = event.target.closest(".product-related-colors__related");
      if (target && target.classList.contains('product-related-colors__related')) {
        currentColorText.innerText = target.getAttribute('aria-label');
      }
    });

    this.relatedColorsContainer[0].addEventListener('mouseout', function (event) {
      const target = event.target;
      if (target.classList.contains('product-related-colors__related')) {
        currentColorText.innerText = currentColor.getAttribute('aria-label');
      }
    });
  }

  _getRelatedColorJSON(url) {
    return fetch(url)
      .then(response => response.text())
      .then((text) => {
        const html = text;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const JSONcontainer = parsedHTML.querySelector('[js-collection-json]');
        const parsedJSON = JSON.parse(JSONcontainer.innerHTML);
        return parsedJSON;
      })
  }

  _initProductForm() {
    const form = this.querySelector(this._selectors.form);

    if (!form) return;


    form.addEventListener('submit', evt => {
      evt.preventDefault();

      if (this.atc.dataset.selectSize == 'true') {
        this.atc.innerHTML = window.strings.select_a_size;
        return;
      }

      const productOptions = this.querySelectorAll('product-options .product-option')

      let atcErrorMsg

      for (let index = 0; index < productOptions.length; index++) {
        const option = productOptions[index];
        const isSelected = option.dataset.validated

        // skip this option if already selected
        if (isSelected == null || isSelected == 'true') continue

        // set button error message
        if (isSelected == 'false') atcErrorMsg = window.strings.select_all_options

      }

      if (atcErrorMsg) {
        this.atc.innerHTML = atcErrorMsg;
        return;
      }

      this._disableButtons()
      document.body.addEventListener("toast:dequeue", this._enableButtons.bind(this))
      document.addEventListener("CartDrawer:close", this._enableButtons.bind(this));

      theme.CartAPI.addFromForm(form)
        .then((res) => {
          if (res.status && res.status >= 300) throw res;

          const optionSelector = this.querySelector("product-options");
          const variant = this.currentVariant || optionSelector._currentVariant;


          theme.Toast.open({
            title: window.strings.toast_title,
            primaryActionLink: "/checkout",
            primaryActionTitle: window.strings.checkout,
            secondaryAction: () => theme.AjaxCart.open(),
            secondaryActionTitle: window.strings.view_cart,
            content: `
            <h2 class="font-700 text-12 leading-16">${this.product.title}</h2>
            <div class="flex justify-between items-start mt-xs">
              <h3 class="font-400 text-12 leading-none uppercase">${variant.title}</h3>
              <p class="leading-none">${theme.utils.formatMoney(variant.price)}</p>
            </div>
          `,
          });
        })
        .catch((e) => {
          console.error(e);

          const message =
            e.description ||
            e.message ||
            "There has been an error while adding your item to cart. This can be due to inventory issues.";

          theme.Toast.open({
            title: "ERROR",
            content: `<p>${message}</p>`,
          });
        });
    })
  }

  _handleVariantChange = (evt) => {
    const { variant, priceChange, container } = evt.detail
    this.currentVariant = variant;
    const parentContainer = container.closest(`.product-option[data-name="${container.dataset.type}"]`)
    if (parentContainer) parentContainer.setAttribute('data-validated', 'true')

    if (this.buyItNow) {
      this.buyItNow.setAttribute('data-variant', this.currentVariant.id)
    }

    this._updateAddToCartState(variant)
  }

  _disableButtons() {
    const addToCart = this.querySelector(this._selectors.addToCart)

    addToCart.setAttribute("disabled", "");
    addToCart.innerHTML = window.strings.item_added;
    const loader = addToCart.querySelector(this._selectors.loader);
    if (loader) {
      loader.setAttribute("loading", "");
    }

    if (this.buyItNow) {
      this.buyItNow.setAttribute("disabled", "");
      const loader = this.buyItNow.querySelector(this._selectors.loader);
      if (loader) {
        loader.setAttribute("loading", "");
      }
    }
  }

  _enableButtons() {
    const addToCart = this.querySelector(this._selectors.addToCart)

    addToCart.removeAttribute("disabled");
    addToCart.innerHTML = window.strings.add_to_cart;
    const addToCartLoader = addToCart.querySelector(this._selectors.loader);
    if (addToCartLoader) {
      addToCartLoader.removeAttribute("loading");
    }

    if (this.buyItNow) {
      this.buyItNow.removeAttribute("disabled", "");
      const buyItNowLoader = this.buyItNow.querySelector(this._selectors.loader);
      if (buyItNowLoader) {
        buyItNowLoader.removeAttribute("loading");
      }
    }
  }

  _updateAddToCartState(variant) {
    const addToCart = this.querySelector(this._selectors.addToCart)

    if (variant) {
      addToCart.setAttribute('data-select-size', 'false');
      if (variant.available) {
        addToCart.removeAttribute('disabled');
        addToCart.innerHTML = window.strings.add_to_cart;

        if (this.buyItNow) {
          this.buyItNow.classList.remove("hidden");
          this.buyItNow.removeAttribute("disabled", "");
        }
      } else {
        addToCart.setAttribute('disabled', 'disabled');
        addToCart.innerHTML = window.strings.sold_out;

        if (this.buyItNow) {
          this.buyItNow.classList.add("hidden");
          this.buyItNow.setAttribute("disabled", "");
        }
      }
    } else {
      addToCart.setAttribute('disabled', 'disabled');
      addToCart.innerHTML = window.strings.unavailable;

      if (this.buyItNow) {
        this.buyItNow.classList.add("hidden");
        this.buyItNow.setAttribute("disabled", "");
      }
    }
  }

  _buyItNow = evt => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    const variant = this.buyItNow.getAttribute('data-variant')

    document.location.href = `/cart/${variant}:1`
  }
}

customElements.define('s-product', ProductMain);

class BlogGrid extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      blogGrid: '[js-blog-grid]'
    }

    // cache fetches for performance
    this._cache = []
  }

  connectedCallback() {
    this._blogGrid = this.querySelector(this._selectors.blogGrid);
    this._initMasonry();
  }

  _initMasonry() {
    const blogGrid = this.querySelector(this._selectors.blogGrid);

    enquire.register("screen and (min-width: 64em)", {
      match: function () {
        if (!blogGrid.classList.contains("initialized")) {
          Promise.all(Array.from(blogGrid.querySelectorAll('img')).filter(img => !img.complete).map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))).then(() => {
            var msnry = new Masonry(blogGrid, {
              itemSelector: '.grid-item',
              gutter: 16
            });
            blogGrid.classList.add("initialized");
          });
        }
      },
      unmatch: function () {
        if (blogGrid.classList.contains("initialized")) {
          var msnry = Masonry.data(blogGrid);
          msnry.destroy();
          blogGrid.classList.remove("initialized");
        }
      }
    });
  }
}

customElements.define("s-blog-grid", BlogGrid);

//Mega menu
document
  .querySelectorAll(".header__inline-menu details-disclosure > details")
  .forEach(function (element) {
    element.addEventListener(
      "mouseenter",
      function () {
        if (!element.hasAttribute('open')){
          element.setAttribute("open", "");
        }
      },
      false
    );
    element.addEventListener(
      "mouseleave",
      function () {
        if (element.hasAttribute('open')){
          element.removeAttribute("open");
        }
      },
      false
    );
  });

document
  .querySelectorAll(".header__submenu details")
  .forEach(function (element) {
    element.setAttribute("open", "");
  });

document.querySelectorAll(".submenu_parent").forEach(function (element) {
  element.addEventListener(
    "click",
    function (e) {
      var clickedDetailsElement = e.target.parentElement;
      document.querySelectorAll(".submenu_parent").forEach(function (el) {
        if (el.parentElement != clickedDetailsElement) {
          el.parentElement.removeAttribute("open");
        }
      });
    },
    false
  );
});

document
  .querySelectorAll(".menu-drawer__navigation summary:not(.submenu_parent)")
  .forEach(function (element) {
    element.addEventListener(
      "click",
      function (e) {
        var clickedDetailsElement = e.target.parentElement;
        document
          .querySelectorAll(
            ".menu-drawer__navigation summary:not(.submenu_parent)"
          )
          .forEach(function (el) {
            if (el.parentElement != clickedDetailsElement) {
              el.parentElement.removeAttribute("open");
            }
          });
      },
      false
    );
  });